<!-- 
Dialog for emailing a notice template to a user.
-->
<template>
  <v-dialog :value="show" persistent content-class="dialog md" @keydown.esc="hide">
    <v-card flat>
      <v-toolbar color="secondary" flat dark>
        <v-toolbar-title>
          {{ title }}
        </v-toolbar-title>
        <v-spacer/>
        <our-user-guide-button topic="levy-collection-setup" section="notice-templates" />
      </v-toolbar>
      <our-busy-indicator :show="busy"/>
      <v-card-text>
        <p class="content">To: <span class="font-weight-medium">{{ myEmail }}</span></p>
        <div class="scrollable-view">
          <notice-template-preview-panel 
            v-if="show" 
            ref="preview" 
            :levy-collection-id="levyCollectionId" 
            :notice-type="noticeType"
          />
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn :disabled="busy" flat @click="hide">Cancel</v-btn>
        <v-btn :disabled="busy" flat color="primary" @click="sendEmail" >Send Email</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import NoticeTemplatePreviewPanel from "@/components/notice-templates/NoticeTemplatePreviewPanel.vue";
import lookupMixins from "@/mixins/lookup.mixins";
import ruleMixins from "@/mixins/rule.mixins";
import * as action from "@/store/notice-templates/action-types";

export default {
  components: {
    NoticeTemplatePreviewPanel
  },
  mixins: [lookupMixins, ruleMixins],
  model: {
    prop: "show",
    event: "update:show"
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    levyCollectionId: {
      type: Number,
      default: null
    },
    noticeType: {
      type: String,
      default: null
    }
  },
  computed: {
    state() {
      return this.$store.state.noticeTemplates.emailPreview;
    },
    request() {
      return this.state.request;
    },
    preview() {
      return this.$store.state.noticeTemplates.preview.data;
    },
    noticeTypeText() {
      return this.lookups.noticeTypeDescriptions[this.noticeType];
    },
    title() {
      return !this.busy && this.noticeTypeText
        ? `Email preview of ${this.noticeTypeText.toLowerCase()}`
        : "Email preview of notice template";
    },
    busy() {
      return this.preview.loading || this.state.sending;
    },
    myEmail() {
      return this.$store.state.users.user.details.email;
    }
  },
  watch: {
    show(showing) {
      if (showing) {
        this.load();
      }
    }
  },
  methods: {
    async load() {
      await this.$store.dispatch(action.PREVIEW_GET, {
        levyCollectionId: this.levyCollectionId,
        noticeType: this.noticeType
      });
      this.$emit("loaded");
    },
    async sendEmail() {
      await this.$store.dispatch(action.PREVIEW_SEND_EMAIL, {
        levyCollectionId: this.levyCollectionId,
        noticeType: this.noticeType
      });
      this.hide();
    },
    hide() {
      this.$emit("update:show", false);
    }
  }
};
</script>

<style lang="scss" scoped>
.content {
  font-size: 16px;
}
.scrollable-view {
  max-height: 400px;
  overflow-y: auto;
}
</style>